import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import type { CardProperties } from '../types';
import { TileCardVariants } from '../types';

@Component({
    selector: 'fcp-tile-card',
    templateUrl: './fcp-tile-card.component.html',
    styleUrls: ['./fcp-tile-card.component.less'],
    standalone: false
})
export class FcpTileCardComponent implements OnInit {
    @Input() properties: CardProperties;
    @Output() click: EventEmitter<any> = new EventEmitter<any>();

    public buttonsInfo: {
        key: string;
        label: string;
        type: string;
    }[] = [];
    ngOnInit() {
        if (this.properties.actionsList.length > 0)
            this.buttonsInfo.push(
                ...this.properties.actionsList.slice(0, 2).map((action) => ({
                    ...action,
                    type: 'outlined'
                }))
            );
        if (this.buttonsInfo.length === 2) this.buttonsInfo[0].type = 'primary';
    }

    onButtonClick(event: MouseEvent, actionKey: string) {
        event.stopPropagation();
        this.click.next(actionKey);
    }
    getCardVariant(variantName: keyof typeof TileCardVariants): string {
        return TileCardVariants[variantName];
    }
}
